export const resetHoverStyles = (controls) => {
    let hoverStyles = {};
    controls.forEach(c => {
        hoverStyles[c.id] = {};
    });
    return hoverStyles;
};